<template>
	<v-app id="register-completed">
		<v-container fluid fill-height>
			<v-layout align-center justify-center>
				<div class="text-md-center">
					<h1>Dziękujemy za rejestrację</h1>
					<h2 class="my-3 headline">Na email <b style="16px">{{email}}</b> został wysłany link weryfikacyjny</h2>
				</div>
			</v-layout>
		</v-container>
	</v-app>
</template>

<script>
	export default {
		name: "RegistrationCompletedView",

		data() {
			return {
				email: "",
			};
		},


		beforeMount() {
			this.email = this.$route.query.email;
		},
	};
</script>

<style scoped>
	h2 b {
		font-size: 24px;
	}
</style>

